import { useHistory } from "react-router-dom";
import styles from './index.module.css';
import { Box, Chip, Typography } from '@material-ui/core';
import { toCurrency } from '../../../utils';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus } from "../../../../reducers/bookings/types";
export interface IInvoiceBalance {
  sundryInvoiceAmountDue: number
  totalAmountDue: number
  totalInvoicesDue: number
  unpaidSundryInvoices: number
}

const InvoiceBalanceCard = ({ data }: { data: IInvoiceBalance }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation()

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:dailyBalance")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #dc2626, #ef4444)" }}>
            💰
          </Box>
        </Box>

        <Box>
          <Box textAlign="center" style={{ margin: "15px 0" }}>
            <Typography variant="body2" style={{ color: "#64748b", fontSize: "14px", marginBottom: "5px" }}>
              {t("root:totalOutstanding")}
            </Typography>
            <Typography
              variant="h2"
              style={{
                fontWeight: 700,
                color: "#dc2626",
                fontSize: "32px",
                lineHeight: "1.2",
              }}
            >
              {toCurrency(data.totalAmountDue, currency, locale)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" justifyContent="center" style={{ marginBottom: "10px" }}>
            <Typography variant="body2" style={{ color: "#64748b" }}>
              {t("root:UnpaidInvoices")}:
            </Typography>
            <Chip
              label={data.totalInvoicesDue}
              size="small"
              style={{
                marginLeft: "8px",
                background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
                color: "white",
                fontWeight: 600,
                cursor: "pointer"
              }}
              onClick={() => {
                history.push("/account/invoices", {
                  applyFilters: {
                    invoiceStatuses: [InvoiceStatus.UNPAID, InvoiceStatus.PARTIALLY_PAID],
                  },
                });
              }}
            />
          </Box>

          <Box display="flex" justifyContent="space-between" style={{ gap: "12px" }}>
            <Box className={styles.statItem} style={{ flex: 1 }}>
              <Typography variant="body2" style={{ color: "#64748b", fontSize: "12px" }}>
                {t("root:regularInvoices")}
              </Typography>
              <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "16px" }}>
                {toCurrency(data.totalAmountDue - data.sundryInvoiceAmountDue, currency, locale)}
              </Typography>
            </Box>
            <Box className={styles.statItem} style={{ flex: 1 }}>
              <Typography variant="body2" style={{ color: "#64748b", fontSize: "12px" }}>
                {t("root:sundryInvoices")}
              </Typography>
              <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "16px" }}>
                {toCurrency(data.sundryInvoiceAmountDue, currency, locale)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default InvoiceBalanceCard